import { FreshworksHelper } from "app/helpers/freshworksHelper";
import isPublicView from "app/utils/publicViewUtils";
import dayjs from "dayjs";
import React, { Component } from "react";
import Media from "react-media";
import { connect } from "react-redux";
import * as summaryApi from "../../../../api/summaryApi";
import BetDrawerButton from "../../../../components/BetDrawerButton/BetDrawerButton";
import ScrollToTop from "../../../../components/ScrollToTop/ScrollToTop";
import ListRenderLogic from "../../../../logic/listRenderLogic";
import SummaryLogic from "../../../../logic/summaryLogic";
import type { CompetitionType } from "../../../../types/competitionType";
import type { RouterMatchType } from "../../../../types/types";
import type { UserType } from "../../../../types/userType";
import {
  competitionListTimeEnum,
  EuroOrderByOptions,
  eventGoneLiveInterval,
  PollingIntervals,
  ResponsiveScreenSizes,
} from "../../../../utils/const";
import CompetitionCell from "../../../EventsScreen/components/CompetitionCell/CompetitionCell";
import EventsScreenMarketsHeader from "../../components/AsianEventScreenMarketsHeader/AsianEventScreenMarketsHeader";
import EventsScreenHeader from "../../components/AsianEventsScreenHeader/AsianEventsScreenHeader";
import "./AsianCompetitionsScreen.scss";
import AsianGlobalEventsNavigation from "./components/AsianGlobalEventsNavigation/AsianGlobalEventsNavigation";
import CompetitionsScreenContents from "./components/CompetitionsScreenContents/CompetitionsScreenContents";
import CompetitionsScreenListBottomSpacer from "./components/CompetitionsScreenListBottomSpacer/CompetitionsScreenListBottomSpacer";
import RenderCompetitionList from "./components/RenderCompetitionList/RenderCompetitionList";
import RenderEndOfList from "./components/RenderEndOfList/RenderEndOfList";
type Props = {
  match: RouterMatchType;
  competitionList: CompetitionType[];
  competitionListTotal: number;
  competitionListOffset: number;
  competitionListReachedEnd: boolean;
  isCompetitionListLoading: boolean;
  setCompetitionListLoading: boolean;
  competitionListNumberLiveEvents: number;
  loadCompetitions: (...args: Array<any>) => any;
  setCompetitions: (...args: Array<any>) => any;
  setSingleCompetition: (...args: Array<any>) => any;
  resetCompetitions: (...args: Array<any>) => any;
  resetFiltering: (...args: Array<any>) => any;
  filterNavNodeIds: string;
  isIdle: boolean;
  user: UserType;
  isUserLoading: boolean;
  selectedCompetitionType: string;
  orderBy: string;
  setBookmarksOnly: (...args: Array<any>) => any;
  loadFavouritesCount: (...args: Array<any>) => any;
  disableFilterTab: boolean;
  disableFilter: (...args: Array<any>) => any;
  disableTodayEarlyFilter: (...args: Array<any>) => any;
  bookmarksTotal: number;
  setCompetitionWithFavouritesList: (...args: Array<any>) => any;
  setFavouritesOnly: (...args: Array<any>) => any;
  loadFavourites: (...args: Array<any>) => any;
  updateSportsSelection: (...args: Array<any>) => any;
  currentFavouritesCount: number;
  navigationMenuOpen: boolean;
  checkIfMenuOpen: (...args: Array<any>) => any;
  favouritesOnly: boolean;
  bookmarksOnly: boolean;
  singleCompetitionOnly: boolean;
  selectedSportTimeFrame: string;
  line: string;
  type: Record<string, any>;
  history: any;
  setPositionMatrixModalEvent: (...args: Array<any>) => any;
  setPositionMatrixModalItem: (...args: Array<any>) => any;
  resetPositionMatrix: (...args: Array<any>) => any;
  openPositionMatrixModal: (...args: Array<any>) => any;
  defaultSportId: number;
  sportsSelectionList: Record<string, any>;
  sportId: number;
  sportsSelectionLoaded: boolean;
  updateAsianPreGameEventsOnly: (...args: Array<any>) => any;
  showUnsummarizedMarketsModal: boolean;
  isPageVisible: Boolean;
  unsetUnsummarizedMarketsModalToOpen: (...args: Array<any>) => any;
  selectedDate: string;
  fullListLoaded: boolean;
  unfilteredCompetitionCount: number;
  searchResult: boolean;
  setFilter: (payload: { [key: string]: boolean | string }) => void;
  setFilters: (payload: [{ [key: string]: boolean | string }]) => void;
};
type State = {
  favouritesActive: boolean;
  singleCompetitionViewActive: boolean;
  positionMatrixOpen: boolean;
  positionMatrixEvent: any;
  competitionsPollIntervalId: any;
  line?: string;
  placeAtEndOfScreen: boolean;
  timeOfLastPoll: Record<string, any>;
  selectedLanguage: string;
};

class AsianCompetitionsScreen extends Component<Props, State> {
  _cache: any;
  _list: any;
  list: any;
  isUserLoaded: boolean;
  accountStatsIntervalId: any;
  favouritesLoading: boolean;

  constructor(props: Props) {
    super(props);
    this.state = {
      favouritesActive: this.props.favouritesOnly,
      singleCompetitionViewActive: this.props.singleCompetitionOnly,
      positionMatrixOpen: false,
      positionMatrixEvent: null,
      competitionsPollIntervalId: 0,
      placeAtEndOfScreen: false,
      timeOfLastPoll: {},
      selectedLanguage: "en",
    };
    this.isUserLoaded = false;
    this.list = React.createRef();
    // Tracking favourites loading state separately
    // The default loading state logic for other list types is incompatible
    this.favouritesLoading = false;
    this.startAccountStatsInterval();
    this.props.loadFavouritesCount();
    !isPublicView() && FreshworksHelper.hideWidget();
  }

  componentDidMount() {
    // When navigating away and then back to favourites,
    // eg favs then go to reports then back to favs, need to reload the list of favourites.
    // So if there are favourited events, and the competition list is empty then reload favourites
    if (
      this.props.favouritesOnly &&
      !this.favouritesLoading &&
      this.props.currentFavouritesCount > 0 &&
      this.props.competitionList &&
      this.props.competitionList.length === 0
    ) {
      this.favouritesLoading = true;
      this.props.loadFavourites(() => {
        this.props.setCompetitionWithFavouritesList({
          showMarketsGroupedByPeriodAndType: true,
        });
        this.favouritesLoading = false;
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    !isPublicView() && FreshworksHelper.hideWidget();
    const {
      competitionList,
      isCompetitionListLoading,
      unfilteredCompetitionCount,
    } = this.props;

    if (
      ListRenderLogic.utilizeWindowList(
        unfilteredCompetitionCount,
        this.props.line
      )
    ) {
      competitionList.forEach((comp, index) => {
        if (comp.events && comp.events.length === 0) {
          setTimeout(() => {
            this.resizeCell(index);
          }, 0);
        }
      });

      // If the competition list has been updated with new items
      // which means that the loading is done
      if (!isCompetitionListLoading && prevProps.isCompetitionListLoading) {
        // Then clear the calculated height of the list
        this.resizeCell();
      }

      // Clear cache of list if any events in a competition has been removed
      // First check if the competition list had items in it before the update
      if (
        prevProps.competitionList != null &&
        prevProps.competitionList.length > 0
      ) {
        prevProps.competitionList.every(prevCompetition => {
          // find the same competition in current list of competitions
          const newCompetitionIndex = competitionList.findIndex(
            competition =>
              competition.id === prevCompetition.id &&
              competition.live === prevCompetition.live
          );
          const newCompetition = competitionList[newCompetitionIndex];

          // if same competition is found
          // and its number of shown events (not the total number of events)
          // is different from the previous competition
          if (
            newCompetition != null &&
            newCompetition.events.length !== prevCompetition.events.length
          ) {
            // then clear calculated height of the competition cell
            setTimeout(() => {
              this.resizeCell(newCompetitionIndex);
            }, 0);
            return false; // break loop
          }

          return true; // continue loop
        });
      }
    }

    // If the user model was previously loading then reload the competitions
    if (!this.props.searchResult) {
      if (
        !this.isUserLoaded &&
        !this.props.favouritesOnly &&
        !this.props.isUserLoading &&
        this.props.sportsSelectionLoaded
      ) {
        this.isUserLoaded = true;
        this.props.setCompetitions();
      } else if (
        !isCompetitionListLoading &&
        this.isUserLoaded &&
        !this.props.fullListLoaded &&
        this.props.sportsSelectionLoaded
      ) {
        this.loadFullList();
      }
    }

    // Start polling if not already started
    if (
      this.state.competitionsPollIntervalId === 0 &&
      this.props.fullListLoaded
    ) {
      this.startCompetitionsPolling();
    }

    // Stop and restart polling, after a change in LIVE or TODAY/EARLY
    // TODO instead doing a check here, trigger the poll from sportsSelection when something changes there
    if (
      this.state.competitionsPollIntervalId &&
      prevProps.selectedSportTimeFrame !== this.props.selectedSportTimeFrame
    ) {
      this.stopCompetitionsPolling();
      this.startCompetitionsPolling();
    }

    // If page was not visible due to using other tab, window minimised etc
    // refresh the competitions list and restart polling
    if (this.props.isPageVisible && !prevProps.isPageVisible) {
      this.props.setCompetitions();

      this.stopCompetitionsPolling();
      this.startCompetitionsPolling();
    }

    if (
      this.props.selectedSportTimeFrame === competitionListTimeEnum.EARLY &&
      this.props.selectedDate !== prevProps.selectedDate &&
      this.props.sportsSelectionLoaded
    ) {
      this.props.resetCompetitions();
      this.props.setCompetitions();
    }

    this.checkSelectedLanguage();
  }

  componentWillUnmount() {
    this.props.resetCompetitions();
    this.clearAccountStatsInterval();
    this.stopCompetitionsPolling();
    // ARCH-85 close unsummarised market view modal if open
    this.closeModal();
  }

  closeModal = () => {
    this.props.unsetUnsummarizedMarketsModalToOpen();
  };

  handleChangeListType = typeChange => {
    const {
      // updateAsianCompetitionListType,
      competitionList,
      resetCompetitions,
      setCompetitions,
      setFilter,
    } = this.props;
    // update store competition type with change
    this.stopCompetitionsPolling();
    // updateAsianCompetitionListType(typeChange);
    setFilter({ orderBy: typeChange.toUpperCase() });

    // if previos collectionlist exist reset
    if (competitionList.length > 0) resetCompetitions(typeChange);
    // get new compeitionsList
    setCompetitions();
  };

  startAccountStatsInterval() {
    // Poll account stats as bookmarks get removed if events are removed
    // Too much processing server-side to send websockets
    this.accountStatsIntervalId = setInterval(() => {
      if (!this.props.isIdle) {
        summaryApi.fetchSummary().then(resp => {
          SummaryLogic.updateSummary(resp.accountStats);
        });
        this.props.updateSportsSelection();
      }
    }, 20000);
  }

  startCompetitionsPolling() {
    const pollingInterval =
      this.props.selectedSportTimeFrame ===
      EuroOrderByOptions.LIVE.toUpperCase()
        ? PollingIntervals.LIVE
        : PollingIntervals.DATE;

    const competitionsPollIntervalId = setInterval(
      () => {
        if (this.props.isIdle) return;
        this.setState({
          timeOfLastPoll: dayjs(),
        });
        this.props.setCompetitions({ fullList: true });
      },
      pollingInterval,
      this
    );
    this.setState({
      competitionsPollIntervalId,
    });
  }

  stopCompetitionsPolling() {
    console.log("stopCompetitionsPolling ");
    // if this is triggered as undefined, then return - side effect of refactoring
    clearInterval(this.state.competitionsPollIntervalId);
    this.setState({
      competitionsPollIntervalId: 0,
    });
  }

  loadFullList = () => {
    if (this.props.fullListLoaded || !this.props.sportsSelectionLoaded) return;
    this.props.setCompetitions({ fullList: true });
  };

  clearAccountStatsInterval() {
    clearInterval(this.accountStatsIntervalId);
  }

  eventHasGoneLive() {
    // When an event goes live, it moves from non live competition to live competition
    // competition list needs to be fetched for the new competition/event to be added
    // in some cases it is too long to wait so need to trigger a fetch of the competitions list
    // Here, check how long has elapsed since the last poll
    // if greater than eventGoneLiveInterval then poll to get the updated comp list
    // and restart polling
    if (
      dayjs().diff(this.state.timeOfLastPoll, "seconds") > eventGoneLiveInterval
    ) {
      this.stopCompetitionsPolling();
      this.props.setCompetitions();
      this.startCompetitionsPolling();
    }
  }

  handleChangeOddsType = () => {
    // update store competition type with change
    // if previous collectionlist exist reset
    if (this.props.competitionList.length > 0) this.props.resetCompetitions();
    // get new compeitionsList
    this.props.setCompetitions();

    // BET-5516 if user has favourites page selected
    if (this.props.favouritesOnly) {
      // if user changes odds while favourites view selected
      if (this.props.competitionList.length > 0) this.props.resetCompetitions();
      this.props.loadFavourites(() => {
        this.props.setCompetitionWithFavouritesList();
      }, this.props.line);
    }
  };
  rowRenderer = ({ index, style }) => {
    let content;
    const {
      line,
      fullListLoaded,
      competitionList,
      setCompetitionWithFavouritesList,
    } = this.props;

    if (competitionList[index] && competitionList[index].events.length === 0) {
      return null;
    }

    const competition: CompetitionType = competitionList[index];
    content =
      competition != null ? (
        <CompetitionCell
          data={competition}
          resizeCell={this.resizeCell}
          competitionIndex={index}
          key={competition.id}
          setCompetitionWithFavouritesList={setCompetitionWithFavouritesList}
          line={line}
          eventHasGoneLive={this.eventHasGoneLive.bind(this)}
          listSize={competitionList.length}
        />
      ) : (
        <CompetitionsScreenListBottomSpacer
          competitionList={competitionList}
          fullListLoaded={fullListLoaded}
        />
      );
    return (
      <div key={index} style={style}>
        {content}
      </div>
    );
  };
  onClickBookmarks = () => {
    const {
      bookmarksOnly,
      competitionList,
      setBookmarksOnly,
      setCompetitions,
      resetCompetitions,
      updateAsianPreGameEventsOnly,
    } = this.props;

    if (!this.props.sportsSelectionLoaded) {
      return;
    }

    const _bookmarksOnly = !bookmarksOnly;

    if (competitionList.length > 0) resetCompetitions();
    setBookmarksOnly(_bookmarksOnly);
    setCompetitions();
    // updateAsianPreGameEventsOnly(false); // PREGAMEONLY filter is only available for TODAY so reset when changing
    this.props.setFilter({ asianPreGameEventsOnly: false });
  };
  resetFiltering = () => {
    const { resetFiltering, disableFilter, disableTodayEarlyFilter } =
      this.props;
    resetFiltering();
    disableFilter(false);
    disableTodayEarlyFilter(false);
  };
  onClickFavourites = () => {
    if (!this.props.sportsSelectionLoaded) {
      return;
    }
    if (this.props.favouritesOnly) {
      this.props.setFavouritesOnly(false);
      if (this.props.competitionList.length > 0) this.props.resetCompetitions();

      if (this.props.singleCompetitionOnly) {
        this.props.setSingleCompetition();
      } else {
        this.props.setCompetitions();
      }
    } else {
      this.props.setFavouritesOnly(true);
      this.favouritesLoading = true;
      if (this.props.competitionList.length > 0) this.props.resetCompetitions();
      this.props.loadFavourites(() => {
        this.props.setCompetitionWithFavouritesList({
          line: this.props.line,
        });
        this.favouritesLoading = false;
        this.resizeCell();
      }, this.props.line);
    }

    this.setState({
      favouritesActive: !this.props.favouritesOnly,
    });
    // this.props.updateAsianPreGameEventsOnly(false); // PREGAMEONLY filter is only available for TODAY so reset when changing
    this.props.setFilter({ asianPreGameEventsOnly: false });
  };
  onClickClosePositionMatrix = () => {
    this.props.resetPositionMatrix();
    this.setState({
      positionMatrixOpen: false,
    });
  };
  // clear the cache of the cell and the list
  resizeCell = (index?: number) => {
    const utilizeWindowList = ListRenderLogic.utilizeWindowList(
      this.props.unfilteredCompetitionCount,
      this.props.line
    );

    if (utilizeWindowList && this.list && this.list.current) {
      if (index) {
        this.list.current.resetAfterIndex(index);
      } else {
        this.list.current.resetAfterIndex(0);
      }
    }
  };
  selectLine = (e: any) => {
    if (this.props.competitionList.length > 0) {
      this.props.resetCompetitions();
    }

    this.stopCompetitionsPolling();

    if (this.props.favouritesOnly) {
      this.favouritesLoading = true;
      this.props.loadFavourites(() => {
        this.favouritesLoading = false;
        this.props.setCompetitionWithFavouritesList({
          line: e.value,
        });
        this.resizeCell();
      }, e.value);
    } else {
      this.props.setFilter({ line: e.value });
      this.props.setCompetitions();
    }
  };
  togglePreGameEventsOnly = (e: any) => {
    const {
      // updateAsianPreGameEventsOnly,
      competitionList,
      setCompetitions,
      resetCompetitions,
    } = this.props;
    // updateAsianPreGameEventsOnly(e.value === "PREGAMEONLY" ? true : false);
    this.props.setFilter({
      asianPreGameEventsOnly: e.value === "PREGAMEONLY" ? true : false,
    });
    // if previos collectionlist exist reset
    if (competitionList.length > 0) resetCompetitions();
    // get new compeitionsList
    setCompetitions();
  };
  selectSorting = (e: any) => {
    e.value && this.handleChangeListType(e.value);
  };
  selectLeagues = (compIds: [], activeEventId: null, searchResult: false) => {
    const { competitionList, resetCompetitions, setCompetitions } = this.props;
    this.stopCompetitionsPolling();
    // if previous collectionlist exist reset
    if (competitionList.length > 0) resetCompetitions();
    // get new compeitionsList
    setCompetitions();
  };
  shouldComponentUpdate = (nextProps, nextState) => {
    // if favourites view selected after competitionlist reset
    // clear cache for all rows to recalculate each event row height again
    if (nextState.favouritesActive && nextProps.competitionList.length > 0) {
      this.resizeCell();

      //  extra step to update asian footer for favourites
      if (
        nextProps.competitionList.length !==
          this.props.competitionList.length &&
        this.state.favouritesActive
      ) {
        this.props.updateSportsSelection();
      }
    }

    return true;
  };

  checkClickEvent = () => {
    if (this.props.navigationMenuOpen) {
      this.props.checkIfMenuOpen(false);
    }
  };

  checkSelectedLanguage = () => {
    const { user } = this.props;
    const { selectedLanguage } = this.state;

    // check and update language if updated
    if (user.preferences !== undefined) {
      if (user.preferences.language !== selectedLanguage) {
        this.setState({
          selectedLanguage: user.preferences.language,
        });
      }
    }
  };

  render() {
    const {
      selectedCompetitionType,
      disableFilterTab,
      competitionList,
      competitionListNumberLiveEvents,
      setCompetitionListLoading,
      isCompetitionListLoading,
      showUnsummarizedMarketsModal,
      history,
      bookmarksTotal,
      bookmarksOnly,
      favouritesOnly,
      fullListLoaded,
      line,
      selectedSportTimeFrame,
      setCompetitionWithFavouritesList,
      currentFavouritesCount,
      orderBy,
    } = this.props;

    const utilizeWindowList = ListRenderLogic.utilizeWindowList(
      this.props.unfilteredCompetitionCount,
      this.props.line
    );
    const { selectedLanguage, favouritesActive } = this.state;
    return (
      <div className={`competitions-screen ${selectedLanguage.toLowerCase()}`}>
        <EventsScreenHeader
          competitionListNumberLiveEvents={competitionListNumberLiveEvents}
          callback={this.handleChangeListType}
          onClickBookmarks={this.onClickBookmarks}
          onClickFavourites={this.onClickFavourites}
          bookmarksActive={bookmarksOnly}
          type={selectedCompetitionType}
          disableFilterTab={disableFilterTab}
          currentFavouritesCount={currentFavouritesCount}
          isCompetitionListLoading={isCompetitionListLoading}
          favouritesActive={favouritesActive}
          checkClickEvent={this.checkClickEvent}
          history={history}
          stopCompetitionsPolling={this.stopCompetitionsPolling.bind(this)}
          selectLeagues={this.selectLeagues}
        />
        {/* desktop only component */}
        <AsianGlobalEventsNavigation
          selectLine={this.selectLine}
          selectSorting={this.selectSorting}
          selectLeagues={this.selectLeagues}
          line={line}
          togglePreGameEventsOnly={this.togglePreGameEventsOnly}
          handleChangeOddsType={this.handleChangeOddsType}
        />
        <div
          className={`asian-events-screen__sub-header ${
            orderBy ? orderBy.toLowerCase() : ""
          }`}
          onClick={() => this.checkClickEvent()}
        >
          {competitionList.length > 0 && (
            <Media
              query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
              render={() => <EventsScreenMarketsHeader />}
            />
          )}
        </div>
        <CompetitionsScreenContents
          competitionList={competitionList}
          selectedCompetitionType={selectedCompetitionType}
          isCompetitionListLoading={isCompetitionListLoading}
          setCompetitionListLoading={setCompetitionListLoading}
          bookmarksTotal={bookmarksTotal}
          bookmarksOnly={bookmarksOnly}
          favouritesOnly={favouritesOnly}
          isUserLoaded={this.isUserLoaded}
          time={selectedSportTimeFrame}
          favouritesLoading={this.favouritesLoading}
          selectedLanguage={selectedLanguage}
          showUnsummarizedMarketsModal={showUnsummarizedMarketsModal}
          checkClickEvent={() => this.checkClickEvent()}
          utilizeWindowList={utilizeWindowList}
          renderCompetitionList={
            <RenderCompetitionList
              utilizeWindowList={utilizeWindowList}
              list={this.list}
              showUnsummarizedMarketsModal={showUnsummarizedMarketsModal}
              competitionList={competitionList}
              rowRenderer={this.rowRenderer}
              resizeCell={this.resizeCell}
              setCompetitionWithFavouritesList={
                setCompetitionWithFavouritesList
              }
              line={line}
              eventHasGoneLive={this.eventHasGoneLive.bind(this)}
            />
          }
          renderEndOfList={
            <RenderEndOfList
              fullListLoaded={fullListLoaded}
              competitionList={competitionList}
            />
          }
        />
        {/* mobile only components */}
        <Media
          query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
          render={() => (
            <div>
              <ScrollToTop />
              <BetDrawerButton />
            </div>
          )}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  competitionList: state.competitionListModel.competitionList,
  competitionListTotal: state.competitionListModel.competitionListTotal,
  competitionListOffset: state.competitionListModel.competitionListOffset,
  competitionListReachedEnd:
    state.competitionListModel.hasCompetitionListReachedEnd,
  isCompetitionListLoading: state.competitionListModel.isCompetitionListLoading,
  setCompetitionListLoading:
    state.competitionListModel.setCompetitionListLoading,
  competitionListNumberLiveEvents:
    state.competitionListModel.competitionListNumberLiveEvents,
  filterNavNodeIds: state.navigationModel.filterNavNodeIds,
  user: state.userModel.user,
  isUserLoading: state.userModel.isUserLoading,
  orderBy: state.asianCompetitionListFiltersModel.orderBy,
  disableFilterTab: state.competitionListModel.disableFilterTab,
  bookmarksTotal: state.bookmarkListModel.total,
  currentFavouritesCount: state.favouritesListModel.currentFavouritesCount,
  navigationMenuOpen: state.navigationModel.navigationMenuOpen,
  favouritesOnly: state.competitionListModel.favouritesOnly,
  bookmarksOnly: state.asianCompetitionListFiltersModel.bookmarksOnly,
  singleCompetitionOnly: state.competitionListModel.singleCompetitionOnly,
  line: state.asianCompetitionListFiltersModel.line,
  isIdle: state.sessionModel.isIdle,
  defaultSportId: state.sportsSelectionListModel.defaultId,
  sportsSelectionList: state.sportsSelectionListModel.sportsSelectionList,
  sportId: state.competitionListModel.sportId,
  sportsSelectionLoaded: state.sportsSelectionListModel.sportsSelectionLoaded,
  selectedSportTimeFrame: state.sportsSelectionListModel.selectedSportTimeFrame,
  showUnsummarizedMarketsModal:
    state.competitionListModel.showUnsummarizedMarketsModal,
  isPageVisible: state.sessionModel.isPageVisible,
  selectedDate: state.asianCompetitionListFiltersModel.selectedDate,
  fullListLoaded: state.competitionListModel.fullListLoaded,
  unfilteredCompetitionCount:
    state.competitionListModel.unfilteredCompetitionCount,
  searchResult: state.competitionListModel.searchResult,
});

const mapDispatchToProps = (dispatch: any) => ({
  setCompetitions: options => {
    dispatch.competitionListModel.setAsianCompetitionList(options);
  },
  setSingleCompetition: () => {
    dispatch.competitionListModel.setSingleCompetitionList();
  },
  resetCompetitions: () => {
    dispatch.competitionListModel.resetCompetition();
  },
  resetFiltering: () => {
    dispatch.navigationModel.resetFiltering();
  },
  setBookmarksOnly: (bookmarksOnly: boolean) => {
    dispatch.asianCompetitionListFiltersModel.setFilter({
      bookmarksOnly: bookmarksOnly,
    });
  },
  setFavouritesOnly: (favouritesOnly: boolean) => {
    dispatch.competitionListModel.setFavouritesOnly(favouritesOnly);
  },
  loadFavourites: (callback, line) => {
    dispatch.favouritesListModel.setFavouriteList({
      callback,
      line,
    });
  },
  loadFavouritesCount: () => {
    dispatch.favouritesListModel.getFavouriteListCount();
  },
  disableFilter: disable => {
    dispatch.competitionListModel.disableFilter(disable);
  },
  setCompetitionWithFavouritesList: callback => {
    dispatch.competitionListModel.setCompetitionWithFavouritesList(callback);
  },
  checkIfMenuOpen: value => dispatch.navigationModel.checkIfMenuOpen(value),
  disableTodayEarlyFilter: disable => {
    dispatch.competitionListModel.disableTodayEarlyFilter(disable);
  },
  updateSportsSelection: (after, before) =>
    dispatch.sportsSelectionListModel.updateSportsSelection({
      // End/Start of day is 4:30AM
      after: dayjs().endOf("day").add(4.5, "hours").unix(),
      before: dayjs().endOf("day").add(4.5, "hours").unix(),
    }),
  setPositionMatrixModalEvent: event => {
    dispatch.positionMatrixListModel.setPositionMatrixModalEvent(event);
  },
  setPositionMatrixModalItem: (eventId: number) => {
    dispatch.positionMatrixListModel.setPositionMatrixModalItem({
      eventId: eventId,
    });
  },
  setFilter: payload => {
    dispatch.asianCompetitionListFiltersModel.setFilter(payload);
  },
  resetPositionMatrix: () => {
    dispatch.positionMatrixListModel.closePositionMatrixModal();
  },
  openPositionMatrixModal: () => {
    dispatch.positionMatrixListModel.openPositionMatrixModal();
  },
  unsetUnsummarizedMarketsModalToOpen: () => {
    dispatch.competitionListModel.unsetUnsummarizedMarketsModalToOpen();
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AsianCompetitionsScreen) as any;
